import React, { Component } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../config/fbConfig';
import { useParams } from 'react-router-dom';
import Profile from './Profile';

// Inline withRouter to inject URL params
function withRouter(Component) {
  return function Wrapper(props) {
    const params = useParams();
    return <Component {...props} params={params} />;
  };
}

class UserDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: null,
      loading: true,
      error: null,
    };
  }

  async componentDidMount() {
    const { userId } = this.props.params;

    try {
      const q = query(
        collection(db, 'Member_Profiles'),
        where('User_Id', '==', userId)
      );

      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        const userData = snapshot.docs[0].data(); // assuming only one match
        this.setState({ userData, loading: false });
      } else {
        this.setState({ error: 'User not found', loading: false });
      }
    } catch (err) {
      this.setState({ error: err.message, loading: false });
    }
  }

  render() {
    const { userData, loading, error } = this.state;

    if (loading) return <div className="text-center mt-5">Loading profile...</div>;
    if (error) return <div className="text-danger text-center mt-5">Error: {error}</div>;

    return (
      <div className="container mt-4 mb-5">
        <Profile userData={userData} />
      </div>
    );
  }
}

export default withRouter(UserDetails);
